import AutoResizeTextarea from './AutoResizeTextarea';

type TextAreaFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  hint?: string;
  error?: string;
  showCount?: boolean;
  maxLength?: number;
  minRows?: number;
  className?: string;
};

export default function TextAreaField({
  label,
  value,
  onChange,
  placeholder,
  hint,
  error,
  showCount = false,
  maxLength,
  minRows = 3,
  className,
}: TextAreaFieldProps) {
  const count = value.length;
  const countLabel = maxLength ? `${count}/${maxLength}` : `${count}`;

  return (
    <div className="field-block">
      <label className="field-label">{label}</label>
      <AutoResizeTextarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        minRows={minRows}
        className={`input-field textarea-field ${error ? 'input-error' : ''} ${className || ''}`.trim()}
      />
      {(hint || error || showCount) && (
        <div className="field-meta">
          <span className={error ? 'field-error' : 'field-hint'}>{error || hint || ''}</span>
          {showCount && <span className="field-hint">{countLabel}</span>}
        </div>
      )}
    </div>
  );
}
